const TIMEZONES = [
    {
        "name": "Brazil/Acre",
        "abbrev": "-05",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Brazil/West",
        "abbrev": "-04",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Brazil/East",
        "abbrev": "-02",
        "utc_offset": "0 years 0 mons 0 days -2 hours 0 mins -0.00 secs",
        "is_dst": true
    },
    {
        "name": "Brazil/DeNoronha",
        "abbrev": "-02",
        "utc_offset": "0 years 0 mons 0 days -2 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "posixrules",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Kwajalein",
        "abbrev": "+12",
        "utc_offset": "0 years 0 mons 0 days 12 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Chile/EasterIsland",
        "abbrev": "-05",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": true
    },
    {
        "name": "Chile/Continental",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": true
    },
    {
        "name": "NZ",
        "abbrev": "NZDT",
        "utc_offset": "0 years 0 mons 0 days 13 hours 0 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Antarctica/Palmer",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Antarctica/Rothera",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Antarctica/McMurdo",
        "abbrev": "NZDT",
        "utc_offset": "0 years 0 mons 0 days 13 hours 0 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Antarctica/Mawson",
        "abbrev": "+05",
        "utc_offset": "0 years 0 mons 0 days 5 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Antarctica/Casey",
        "abbrev": "+08",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Antarctica/Syowa",
        "abbrev": "+03",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Antarctica/Davis",
        "abbrev": "+07",
        "utc_offset": "0 years 0 mons 0 days 7 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Antarctica/South_Pole",
        "abbrev": "NZDT",
        "utc_offset": "0 years 0 mons 0 days 13 hours 0 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Antarctica/DumontDUrville",
        "abbrev": "+10",
        "utc_offset": "0 years 0 mons 0 days 10 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Antarctica/Vostok",
        "abbrev": "+06",
        "utc_offset": "0 years 0 mons 0 days 6 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Antarctica/Troll",
        "abbrev": "+00",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Antarctica/Macquarie",
        "abbrev": "+11",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Istanbul",
        "abbrev": "+03",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Copenhagen",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Zagreb",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/London",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Luxembourg",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Gibraltar",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Lisbon",
        "abbrev": "WET",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Saratov",
        "abbrev": "+04",
        "utc_offset": "0 years 0 mons 0 days 4 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Mariehamn",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Isle_of_Man",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Tiraspol",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Nicosia",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Oslo",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Tirane",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Skopje",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Simferopol",
        "abbrev": "MSK",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Budapest",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Samara",
        "abbrev": "+04",
        "utc_offset": "0 years 0 mons 0 days 4 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Uzhgorod",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Berlin",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Ljubljana",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Guernsey",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Vaduz",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Bratislava",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Bucharest",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Zaporozhye",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Dublin",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Europe/Podgorica",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Jersey",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Kirov",
        "abbrev": "+03",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Belgrade",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Brussels",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Athens",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Paris",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Riga",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Andorra",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Rome",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Chisinau",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Busingen",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Warsaw",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Kaliningrad",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Kiev",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Volgograd",
        "abbrev": "+04",
        "utc_offset": "0 years 0 mons 0 days 4 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Moscow",
        "abbrev": "MSK",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Prague",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Astrakhan",
        "abbrev": "+04",
        "utc_offset": "0 years 0 mons 0 days 4 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Tallinn",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Madrid",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Monaco",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Vilnius",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Malta",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Vatican",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Helsinki",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Minsk",
        "abbrev": "+03",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Sofia",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Ulyanovsk",
        "abbrev": "+04",
        "utc_offset": "0 years 0 mons 0 days 4 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/San_Marino",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Zurich",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Vienna",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Belfast",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Amsterdam",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Sarajevo",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Europe/Stockholm",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Kashgar",
        "abbrev": "+06",
        "utc_offset": "0 years 0 mons 0 days 6 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Istanbul",
        "abbrev": "+03",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Gaza",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Anadyr",
        "abbrev": "+12",
        "utc_offset": "0 years 0 mons 0 days 12 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Katmandu",
        "abbrev": "+0545",
        "utc_offset": "0 years 0 mons 0 days 5 hours 45 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Bahrain",
        "abbrev": "+03",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Amman",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Aqtau",
        "abbrev": "+05",
        "utc_offset": "0 years 0 mons 0 days 5 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Jerusalem",
        "abbrev": "IST",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Harbin",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Ulaanbaatar",
        "abbrev": "+08",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Chungking",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Samarkand",
        "abbrev": "+05",
        "utc_offset": "0 years 0 mons 0 days 5 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Kolkata",
        "abbrev": "IST",
        "utc_offset": "0 years 0 mons 0 days 5 hours 30 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Baghdad",
        "abbrev": "+03",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Saigon",
        "abbrev": "+07",
        "utc_offset": "0 years 0 mons 0 days 7 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Krasnoyarsk",
        "abbrev": "+07",
        "utc_offset": "0 years 0 mons 0 days 7 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Dubai",
        "abbrev": "+04",
        "utc_offset": "0 years 0 mons 0 days 4 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Omsk",
        "abbrev": "+06",
        "utc_offset": "0 years 0 mons 0 days 6 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Seoul",
        "abbrev": "KST",
        "utc_offset": "0 years 0 mons 0 days 9 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Nicosia",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Ust-Nera",
        "abbrev": "+10",
        "utc_offset": "0 years 0 mons 0 days 10 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Beirut",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Kathmandu",
        "abbrev": "+0545",
        "utc_offset": "0 years 0 mons 0 days 5 hours 45 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Dacca",
        "abbrev": "+06",
        "utc_offset": "0 years 0 mons 0 days 6 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Manila",
        "abbrev": "PST",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Yekaterinburg",
        "abbrev": "+05",
        "utc_offset": "0 years 0 mons 0 days 5 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Kuala_Lumpur",
        "abbrev": "+08",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Tomsk",
        "abbrev": "+07",
        "utc_offset": "0 years 0 mons 0 days 7 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Tokyo",
        "abbrev": "JST",
        "utc_offset": "0 years 0 mons 0 days 9 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Singapore",
        "abbrev": "+08",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Kamchatka",
        "abbrev": "+12",
        "utc_offset": "0 years 0 mons 0 days 12 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Irkutsk",
        "abbrev": "+08",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Muscat",
        "abbrev": "+04",
        "utc_offset": "0 years 0 mons 0 days 4 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Pyongyang",
        "abbrev": "KST",
        "utc_offset": "0 years 0 mons 0 days 9 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Tbilisi",
        "abbrev": "+04",
        "utc_offset": "0 years 0 mons 0 days 4 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Almaty",
        "abbrev": "+06",
        "utc_offset": "0 years 0 mons 0 days 6 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Yangon",
        "abbrev": "+0630",
        "utc_offset": "0 years 0 mons 0 days 6 hours 30 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Urumqi",
        "abbrev": "+06",
        "utc_offset": "0 years 0 mons 0 days 6 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Hovd",
        "abbrev": "+07",
        "utc_offset": "0 years 0 mons 0 days 7 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Bishkek",
        "abbrev": "+06",
        "utc_offset": "0 years 0 mons 0 days 6 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Aden",
        "abbrev": "+03",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Dili",
        "abbrev": "+09",
        "utc_offset": "0 years 0 mons 0 days 9 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Phnom_Penh",
        "abbrev": "+07",
        "utc_offset": "0 years 0 mons 0 days 7 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Damascus",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Calcutta",
        "abbrev": "IST",
        "utc_offset": "0 years 0 mons 0 days 5 hours 30 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Tashkent",
        "abbrev": "+05",
        "utc_offset": "0 years 0 mons 0 days 5 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Magadan",
        "abbrev": "+11",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Macao",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Yerevan",
        "abbrev": "+04",
        "utc_offset": "0 years 0 mons 0 days 4 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Ho_Chi_Minh",
        "abbrev": "+07",
        "utc_offset": "0 years 0 mons 0 days 7 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Chongqing",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Khandyga",
        "abbrev": "+09",
        "utc_offset": "0 years 0 mons 0 days 9 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Oral",
        "abbrev": "+05",
        "utc_offset": "0 years 0 mons 0 days 5 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Novosibirsk",
        "abbrev": "+07",
        "utc_offset": "0 years 0 mons 0 days 7 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Riyadh",
        "abbrev": "+03",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Bangkok",
        "abbrev": "+07",
        "utc_offset": "0 years 0 mons 0 days 7 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Rangoon",
        "abbrev": "+0630",
        "utc_offset": "0 years 0 mons 0 days 6 hours 30 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Colombo",
        "abbrev": "+0530",
        "utc_offset": "0 years 0 mons 0 days 5 hours 30 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Kabul",
        "abbrev": "+0430",
        "utc_offset": "0 years 0 mons 0 days 4 hours 30 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Jayapura",
        "abbrev": "WIT",
        "utc_offset": "0 years 0 mons 0 days 9 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Baku",
        "abbrev": "+04",
        "utc_offset": "0 years 0 mons 0 days 4 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Atyrau",
        "abbrev": "+05",
        "utc_offset": "0 years 0 mons 0 days 5 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Yakutsk",
        "abbrev": "+09",
        "utc_offset": "0 years 0 mons 0 days 9 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Ujung_Pandang",
        "abbrev": "WITA",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Dhaka",
        "abbrev": "+06",
        "utc_offset": "0 years 0 mons 0 days 6 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Qyzylorda",
        "abbrev": "+06",
        "utc_offset": "0 years 0 mons 0 days 6 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Kuching",
        "abbrev": "+08",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Novokuznetsk",
        "abbrev": "+07",
        "utc_offset": "0 years 0 mons 0 days 7 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Ulan_Bator",
        "abbrev": "+08",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Ashkhabad",
        "abbrev": "+05",
        "utc_offset": "0 years 0 mons 0 days 5 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Taipei",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Vladivostok",
        "abbrev": "+10",
        "utc_offset": "0 years 0 mons 0 days 10 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Karachi",
        "abbrev": "PKT",
        "utc_offset": "0 years 0 mons 0 days 5 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Vientiane",
        "abbrev": "+07",
        "utc_offset": "0 years 0 mons 0 days 7 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Sakhalin",
        "abbrev": "+11",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Thimphu",
        "abbrev": "+06",
        "utc_offset": "0 years 0 mons 0 days 6 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Ashgabat",
        "abbrev": "+05",
        "utc_offset": "0 years 0 mons 0 days 5 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Thimbu",
        "abbrev": "+06",
        "utc_offset": "0 years 0 mons 0 days 6 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Tel_Aviv",
        "abbrev": "IST",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Aqtobe",
        "abbrev": "+05",
        "utc_offset": "0 years 0 mons 0 days 5 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Makassar",
        "abbrev": "WITA",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Hong_Kong",
        "abbrev": "HKT",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Shanghai",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Srednekolymsk",
        "abbrev": "+11",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Qatar",
        "abbrev": "+03",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Choibalsan",
        "abbrev": "+08",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Barnaul",
        "abbrev": "+07",
        "utc_offset": "0 years 0 mons 0 days 7 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Dushanbe",
        "abbrev": "+05",
        "utc_offset": "0 years 0 mons 0 days 5 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Pontianak",
        "abbrev": "WIB",
        "utc_offset": "0 years 0 mons 0 days 7 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Hebron",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Chita",
        "abbrev": "+09",
        "utc_offset": "0 years 0 mons 0 days 9 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Jakarta",
        "abbrev": "WIB",
        "utc_offset": "0 years 0 mons 0 days 7 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Kuwait",
        "abbrev": "+03",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Macau",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Tehran",
        "abbrev": "+0330",
        "utc_offset": "0 years 0 mons 0 days 3 hours 30 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Famagusta",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Asia/Brunei",
        "abbrev": "+08",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Regina",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Marigot",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Dominica",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Barbados",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Pangnirtung",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Asuncion",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": true
    },
    {
        "name": "America/Thule",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Atka",
        "abbrev": "HST",
        "utc_offset": "0 years 0 mons 0 days -10 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Glace_Bay",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Atikokan",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Catamarca",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Scoresbysund",
        "abbrev": "-01",
        "utc_offset": "0 years 0 mons 0 days -1 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Belem",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Montserrat",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Santiago",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": true
    },
    {
        "name": "America/Creston",
        "abbrev": "MST",
        "utc_offset": "0 years 0 mons 0 days -7 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Mendoza",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Bogota",
        "abbrev": "-05",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Caracas",
        "abbrev": "-04",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Dawson_Creek",
        "abbrev": "MST",
        "utc_offset": "0 years 0 mons 0 days -7 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Phoenix",
        "abbrev": "MST",
        "utc_offset": "0 years 0 mons 0 days -7 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Denver",
        "abbrev": "MST",
        "utc_offset": "0 years 0 mons 0 days -7 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Merida",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Puerto_Rico",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Havana",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Guadeloupe",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Montevideo",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Curacao",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/New_York",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Managua",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Aruba",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Chicago",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Maceio",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Panama",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Guyana",
        "abbrev": "-04",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/El_Salvador",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Cayman",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Adak",
        "abbrev": "HST",
        "utc_offset": "0 years 0 mons 0 days -10 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Port-au-Prince",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Anchorage",
        "abbrev": "AKST",
        "utc_offset": "0 years 0 mons 0 days -9 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Virgin",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Bahia",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Buenos_Aires",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Belize",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Nipigon",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Detroit",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Cancun",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Cuiaba",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": true
    },
    {
        "name": "America/Whitehorse",
        "abbrev": "PST",
        "utc_offset": "0 years 0 mons 0 days -8 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Santa_Isabel",
        "abbrev": "PST",
        "utc_offset": "0 years 0 mons 0 days -8 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Lower_Princes",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Ensenada",
        "abbrev": "PST",
        "utc_offset": "0 years 0 mons 0 days -8 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Montreal",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Rankin_Inlet",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Cayenne",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Matamoros",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Yellowknife",
        "abbrev": "MST",
        "utc_offset": "0 years 0 mons 0 days -7 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/St_Johns",
        "abbrev": "NST",
        "utc_offset": "0 years 0 mons 0 days -3 hours -30 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Campo_Grande",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": true
    },
    {
        "name": "America/Sao_Paulo",
        "abbrev": "-02",
        "utc_offset": "0 years 0 mons 0 days -2 hours 0 mins -0.00 secs",
        "is_dst": true
    },
    {
        "name": "America/Hermosillo",
        "abbrev": "MST",
        "utc_offset": "0 years 0 mons 0 days -7 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Guayaquil",
        "abbrev": "-05",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Grenada",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Kentucky/Monticello",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Kentucky/Louisville",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Recife",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Nassau",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Martinique",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Fortaleza",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Dawson",
        "abbrev": "PST",
        "utc_offset": "0 years 0 mons 0 days -8 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Sitka",
        "abbrev": "AKST",
        "utc_offset": "0 years 0 mons 0 days -9 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Argentina/Salta",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Argentina/Ushuaia",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Argentina/Catamarca",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Argentina/Mendoza",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Argentina/La_Rioja",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Argentina/Rio_Gallegos",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Argentina/San_Luis",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Argentina/Buenos_Aires",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Argentina/Tucuman",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Argentina/San_Juan",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Argentina/ComodRivadavia",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Argentina/Jujuy",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Argentina/Cordoba",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Moncton",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Porto_Acre",
        "abbrev": "-05",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Goose_Bay",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Rainy_River",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Jamaica",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Kralendijk",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Metlakatla",
        "abbrev": "AKST",
        "utc_offset": "0 years 0 mons 0 days -9 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Grand_Turk",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Porto_Velho",
        "abbrev": "-04",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Miquelon",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Tortola",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Lima",
        "abbrev": "-05",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Eirunepe",
        "abbrev": "-05",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Mazatlan",
        "abbrev": "MST",
        "utc_offset": "0 years 0 mons 0 days -7 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Indiana/Winamac",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Indiana/Marengo",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Indiana/Tell_City",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Indiana/Petersburg",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Indiana/Vincennes",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Indiana/Knox",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Indiana/Vevay",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Indiana/Indianapolis",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Fort_Nelson",
        "abbrev": "MST",
        "utc_offset": "0 years 0 mons 0 days -7 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Halifax",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Los_Angeles",
        "abbrev": "PST",
        "utc_offset": "0 years 0 mons 0 days -8 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Tegucigalpa",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Thunder_Bay",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Punta_Arenas",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Noronha",
        "abbrev": "-02",
        "utc_offset": "0 years 0 mons 0 days -2 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/St_Vincent",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Danmarkshavn",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Jujuy",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Santarem",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Anguilla",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Winnipeg",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Resolute",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Rosario",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Paramaribo",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Inuvik",
        "abbrev": "MST",
        "utc_offset": "0 years 0 mons 0 days -7 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Cambridge_Bay",
        "abbrev": "MST",
        "utc_offset": "0 years 0 mons 0 days -7 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Juneau",
        "abbrev": "AKST",
        "utc_offset": "0 years 0 mons 0 days -9 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Yakutat",
        "abbrev": "AKST",
        "utc_offset": "0 years 0 mons 0 days -9 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Edmonton",
        "abbrev": "MST",
        "utc_offset": "0 years 0 mons 0 days -7 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Chihuahua",
        "abbrev": "MST",
        "utc_offset": "0 years 0 mons 0 days -7 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Costa_Rica",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Iqaluit",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Manaus",
        "abbrev": "-04",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Vancouver",
        "abbrev": "PST",
        "utc_offset": "0 years 0 mons 0 days -8 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Mexico_City",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Indianapolis",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Louisville",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Rio_Branco",
        "abbrev": "-05",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Blanc-Sablon",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/North_Dakota/Beulah",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/North_Dakota/Center",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/North_Dakota/New_Salem",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Coral_Harbour",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/St_Lucia",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Antigua",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Ojinaga",
        "abbrev": "MST",
        "utc_offset": "0 years 0 mons 0 days -7 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Toronto",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Cordoba",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Bahia_Banderas",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Monterrey",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Nome",
        "abbrev": "AKST",
        "utc_offset": "0 years 0 mons 0 days -9 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Fort_Wayne",
        "abbrev": "EST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Port_of_Spain",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/St_Kitts",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Santo_Domingo",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Araguaina",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Swift_Current",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Boa_Vista",
        "abbrev": "-04",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Tijuana",
        "abbrev": "PST",
        "utc_offset": "0 years 0 mons 0 days -8 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Menominee",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Guatemala",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Shiprock",
        "abbrev": "MST",
        "utc_offset": "0 years 0 mons 0 days -7 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Godthab",
        "abbrev": "-03",
        "utc_offset": "0 years 0 mons 0 days -3 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/La_Paz",
        "abbrev": "-04",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Boise",
        "abbrev": "MST",
        "utc_offset": "0 years 0 mons 0 days -7 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/St_Barthelemy",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/St_Thomas",
        "abbrev": "AST",
        "utc_offset": "0 years 0 mons 0 days -4 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "America/Knox_IN",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "CST6CDT",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "GMT",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "EET",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "PST8PDT",
        "abbrev": "PST",
        "utc_offset": "0 years 0 mons 0 days -8 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Dakar",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Malabo",
        "abbrev": "WAT",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Monrovia",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Douala",
        "abbrev": "WAT",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Mbabane",
        "abbrev": "SAST",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Ouagadougou",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Nairobi",
        "abbrev": "EAT",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Blantyre",
        "abbrev": "CAT",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Gaborone",
        "abbrev": "CAT",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Sao_Tome",
        "abbrev": "WAT",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Dar_es_Salaam",
        "abbrev": "EAT",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Luanda",
        "abbrev": "WAT",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Niamey",
        "abbrev": "WAT",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Abidjan",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Bamako",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Banjul",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Tunis",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Accra",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Bujumbura",
        "abbrev": "CAT",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Libreville",
        "abbrev": "WAT",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Khartoum",
        "abbrev": "CAT",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Lome",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Mogadishu",
        "abbrev": "EAT",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Brazzaville",
        "abbrev": "WAT",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Kampala",
        "abbrev": "EAT",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Maseru",
        "abbrev": "SAST",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Djibouti",
        "abbrev": "EAT",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Kigali",
        "abbrev": "CAT",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Timbuktu",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Tripoli",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Ndjamena",
        "abbrev": "WAT",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Windhoek",
        "abbrev": "CAT",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Juba",
        "abbrev": "EAT",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Porto-Novo",
        "abbrev": "WAT",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/El_Aaiun",
        "abbrev": "+01",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Freetown",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Lagos",
        "abbrev": "WAT",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Bangui",
        "abbrev": "WAT",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Algiers",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Harare",
        "abbrev": "CAT",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Bissau",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Lusaka",
        "abbrev": "CAT",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Cairo",
        "abbrev": "EET",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Asmara",
        "abbrev": "EAT",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Casablanca",
        "abbrev": "+01",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Lubumbashi",
        "abbrev": "CAT",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Addis_Ababa",
        "abbrev": "EAT",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Maputo",
        "abbrev": "CAT",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Johannesburg",
        "abbrev": "SAST",
        "utc_offset": "0 years 0 mons 0 days 2 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Asmera",
        "abbrev": "EAT",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Nouakchott",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Kinshasa",
        "abbrev": "WAT",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Ceuta",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Africa/Conakry",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Japan",
        "abbrev": "JST",
        "utc_offset": "0 years 0 mons 0 days 9 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Cuba",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Midway",
        "abbrev": "SST",
        "utc_offset": "0 years 0 mons 0 days -11 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Port_Moresby",
        "abbrev": "+10",
        "utc_offset": "0 years 0 mons 0 days 10 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Kwajalein",
        "abbrev": "+12",
        "utc_offset": "0 years 0 mons 0 days 12 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Samoa",
        "abbrev": "SST",
        "utc_offset": "0 years 0 mons 0 days -11 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Majuro",
        "abbrev": "+12",
        "utc_offset": "0 years 0 mons 0 days 12 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Easter",
        "abbrev": "-05",
        "utc_offset": "0 years 0 mons 0 days -5 hours 0 mins -0.00 secs",
        "is_dst": true
    },
    {
        "name": "Pacific/Kiritimati",
        "abbrev": "+14",
        "utc_offset": "0 years 0 mons 0 days 14 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Ponape",
        "abbrev": "+11",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Tarawa",
        "abbrev": "+12",
        "utc_offset": "0 years 0 mons 0 days 12 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Auckland",
        "abbrev": "NZDT",
        "utc_offset": "0 years 0 mons 0 days 13 hours 0 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Pacific/Marquesas",
        "abbrev": "-0930",
        "utc_offset": "0 years 0 mons 0 days -9 hours -30 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Chatham",
        "abbrev": "+1345",
        "utc_offset": "0 years 0 mons 0 days 13 hours 45 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Pacific/Tongatapu",
        "abbrev": "+13",
        "utc_offset": "0 years 0 mons 0 days 13 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Honolulu",
        "abbrev": "HST",
        "utc_offset": "0 years 0 mons 0 days -10 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Tahiti",
        "abbrev": "-10",
        "utc_offset": "0 years 0 mons 0 days -10 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Funafuti",
        "abbrev": "+12",
        "utc_offset": "0 years 0 mons 0 days 12 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Noumea",
        "abbrev": "+11",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Chuuk",
        "abbrev": "+10",
        "utc_offset": "0 years 0 mons 0 days 10 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Saipan",
        "abbrev": "ChST",
        "utc_offset": "0 years 0 mons 0 days 10 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Nauru",
        "abbrev": "+12",
        "utc_offset": "0 years 0 mons 0 days 12 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Wake",
        "abbrev": "+12",
        "utc_offset": "0 years 0 mons 0 days 12 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Palau",
        "abbrev": "+09",
        "utc_offset": "0 years 0 mons 0 days 9 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Pitcairn",
        "abbrev": "-08",
        "utc_offset": "0 years 0 mons 0 days -8 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Pago_Pago",
        "abbrev": "SST",
        "utc_offset": "0 years 0 mons 0 days -11 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Kosrae",
        "abbrev": "+11",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Apia",
        "abbrev": "+14",
        "utc_offset": "0 years 0 mons 0 days 14 hours 0 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Pacific/Truk",
        "abbrev": "+10",
        "utc_offset": "0 years 0 mons 0 days 10 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Johnston",
        "abbrev": "HST",
        "utc_offset": "0 years 0 mons 0 days -10 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Fiji",
        "abbrev": "+12",
        "utc_offset": "0 years 0 mons 0 days 12 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Pohnpei",
        "abbrev": "+11",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Guam",
        "abbrev": "ChST",
        "utc_offset": "0 years 0 mons 0 days 10 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Enderbury",
        "abbrev": "+13",
        "utc_offset": "0 years 0 mons 0 days 13 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Wallis",
        "abbrev": "+12",
        "utc_offset": "0 years 0 mons 0 days 12 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Efate",
        "abbrev": "+11",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Gambier",
        "abbrev": "-09",
        "utc_offset": "0 years 0 mons 0 days -9 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Bougainville",
        "abbrev": "+11",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Guadalcanal",
        "abbrev": "+11",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Rarotonga",
        "abbrev": "-10",
        "utc_offset": "0 years 0 mons 0 days -10 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Galapagos",
        "abbrev": "-06",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Fakaofo",
        "abbrev": "+13",
        "utc_offset": "0 years 0 mons 0 days 13 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Yap",
        "abbrev": "+10",
        "utc_offset": "0 years 0 mons 0 days 10 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Niue",
        "abbrev": "-11",
        "utc_offset": "0 years 0 mons 0 days -11 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Pacific/Norfolk",
        "abbrev": "+11",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "WET",
        "abbrev": "WET",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Singapore",
        "abbrev": "+08",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "MST",
        "abbrev": "MST",
        "utc_offset": "0 years 0 mons 0 days -7 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "MET",
        "abbrev": "MET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Turkey",
        "abbrev": "+03",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Poland",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Mexico/BajaNorte",
        "abbrev": "PST",
        "utc_offset": "0 years 0 mons 0 days -8 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Mexico/BajaSur",
        "abbrev": "MST",
        "utc_offset": "0 years 0 mons 0 days -7 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Mexico/General",
        "abbrev": "CST",
        "utc_offset": "0 years 0 mons 0 days -6 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "ROK",
        "abbrev": "KST",
        "utc_offset": "0 years 0 mons 0 days 9 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "GB",
        "abbrev": "GMT",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Australia/Darwin",
        "abbrev": "ACST",
        "utc_offset": "0 years 0 mons 0 days 9 hours 30 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Australia/West",
        "abbrev": "AWST",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Australia/Eucla",
        "abbrev": "+0845",
        "utc_offset": "0 years 0 mons 0 days 8 hours 45 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Australia/Currie",
        "abbrev": "AEDT",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Australia/ACT",
        "abbrev": "AEDT",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Australia/North",
        "abbrev": "ACST",
        "utc_offset": "0 years 0 mons 0 days 9 hours 30 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Australia/NSW",
        "abbrev": "AEDT",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Australia/Melbourne",
        "abbrev": "AEDT",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Australia/Lindeman",
        "abbrev": "AEST",
        "utc_offset": "0 years 0 mons 0 days 10 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Australia/Tasmania",
        "abbrev": "AEDT",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Australia/Perth",
        "abbrev": "AWST",
        "utc_offset": "0 years 0 mons 0 days 8 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Australia/Adelaide",
        "abbrev": "ACDT",
        "utc_offset": "0 years 0 mons 0 days 10 hours 30 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Australia/Queensland",
        "abbrev": "AEST",
        "utc_offset": "0 years 0 mons 0 days 10 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Australia/Lord_Howe",
        "abbrev": "+11",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Australia/Victoria",
        "abbrev": "AEDT",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Australia/Yancowinna",
        "abbrev": "ACDT",
        "utc_offset": "0 years 0 mons 0 days 10 hours 30 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Australia/Broken_Hill",
        "abbrev": "ACDT",
        "utc_offset": "0 years 0 mons 0 days 10 hours 30 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Australia/LHI",
        "abbrev": "+11",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Australia/Canberra",
        "abbrev": "AEDT",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Australia/Hobart",
        "abbrev": "AEDT",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Australia/South",
        "abbrev": "ACDT",
        "utc_offset": "0 years 0 mons 0 days 10 hours 30 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Australia/Brisbane",
        "abbrev": "AEST",
        "utc_offset": "0 years 0 mons 0 days 10 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Australia/Sydney",
        "abbrev": "AEDT",
        "utc_offset": "0 years 0 mons 0 days 11 hours 0 mins 0.00 secs",
        "is_dst": true
    },
    {
        "name": "Universal",
        "abbrev": "UTC",
        "utc_offset": "0 years 0 mons 0 days 0 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "MST7MDT",
        "abbrev": "MST",
        "utc_offset": "0 years 0 mons 0 days -7 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Arctic/Longyearbyen",
        "abbrev": "CET",
        "utc_offset": "0 years 0 mons 0 days 1 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Navajo",
        "abbrev": "MST",
        "utc_offset": "0 years 0 mons 0 days -7 hours 0 mins -0.00 secs",
        "is_dst": false
    },
    {
        "name": "Indian/Comoro",
        "abbrev": "EAT",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Indian/Christmas",
        "abbrev": "+07",
        "utc_offset": "0 years 0 mons 0 days 7 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Indian/Chagos",
        "abbrev": "+06",
        "utc_offset": "0 years 0 mons 0 days 6 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Indian/Mahe",
        "abbrev": "+04",
        "utc_offset": "0 years 0 mons 0 days 4 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Indian/Mauritius",
        "abbrev": "+04",
        "utc_offset": "0 years 0 mons 0 days 4 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Indian/Reunion",
        "abbrev": "+04",
        "utc_offset": "0 years 0 mons 0 days 4 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Indian/Antananarivo",
        "abbrev": "EAT",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Indian/Cocos",
        "abbrev": "+0630",
        "utc_offset": "0 years 0 mons 0 days 6 hours 30 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Indian/Maldives",
        "abbrev": "+05",
        "utc_offset": "0 years 0 mons 0 days 5 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Indian/Kerguelen",
        "abbrev": "+05",
        "utc_offset": "0 years 0 mons 0 days 5 hours 0 mins 0.00 secs",
        "is_dst": false
    },
    {
        "name": "Indian/Mayotte",
        "abbrev": "EAT",
        "utc_offset": "0 years 0 mons 0 days 3 hours 0 mins 0.00 secs",
        "is_dst": false
    }
];
export default TIMEZONES.filter(tz => tz.name.includes('America'));
